"use client";

import { useEffect } from "react";

const COLORS = ["#22c55e", "#3b82f6", "#a855f7", "#f59e0b", "#ec4899", "#14b8a6"];

function fireConfettiBurst() {
  const canvas = document.createElement("canvas");
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  canvas.style.position = "fixed";
  canvas.style.inset = "0";
  canvas.style.pointerEvents = "none";
  canvas.style.zIndex = "9999";
  document.body.appendChild(canvas);

  const context = canvas.getContext("2d");
  if (!context) {
    canvas.remove();
    return;
  }

  const particles = Array.from({ length: 120 }, () => ({
    x: window.innerWidth * 0.5 + (Math.random() - 0.5) * 120,
    y: window.innerHeight * 0.35,
    size: 4 + Math.random() * 6,
    color: COLORS[Math.floor(Math.random() * COLORS.length)],
    velocityX: (Math.random() - 0.5) * 14,
    velocityY: -8 - Math.random() * 10,
    rotation: Math.random() * 360,
    rotationSpeed: (Math.random() - 0.5) * 12,
    gravity: 0.22 + Math.random() * 0.08,
  }));

  let frame = 0;
  const maxFrames = 110;

  const animate = () => {
    context.clearRect(0, 0, canvas.width, canvas.height);

    for (const particle of particles) {
      particle.velocityY += particle.gravity;
      particle.x += particle.velocityX;
      particle.y += particle.velocityY;
      particle.rotation += particle.rotationSpeed;
      particle.velocityX *= 0.99;

      context.save();
      context.translate(particle.x, particle.y);
      context.rotate((particle.rotation * Math.PI) / 180);
      context.fillStyle = particle.color;
      context.fillRect(
        -particle.size / 2,
        -particle.size / 2,
        particle.size,
        particle.size * 0.6
      );
      context.restore();
    }

    frame += 1;
    if (frame < maxFrames) {
      requestAnimationFrame(animate);
      return;
    }

    canvas.remove();
  };

  requestAnimationFrame(animate);
}

export function CelebrationConfetti() {
  useEffect(() => {
    fireConfettiBurst();
  }, []);

  return null;
}
